import { useMutation } from '@tanstack/react-query'

import { registerTfaSmsAuth } from '@src/api'
import { useAxios } from '@src/hooks'

export const useRegisterTfaSmsAuth = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: ({ idToken }: { idToken: string }) =>
      registerTfaSmsAuth(axiosInstance, { idToken }),
  })
}
